import { NgModule } from '@angular/core';

import { AlertComponent } from './alert.component';

@NgModule({
  imports: [AlertComponent],
  exports: [AlertComponent]
})
export class TiimeAlertModule {}
